import React, { useState, useEffect } from 'react';
import TopbarNav from './TopbarNav';
import DesignSidebar from './DesignSidebar';
import Icon from './Icon';
import ToastProvider from './design/Toast';

function MainLayout({
  currentPage, user, onLogout, onNavClick, onOpenPalette,
  sidebarCollapsed, onToggleCollapse, logoUrl, children, ...sidebarProps
}) {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (!mobileOpen) return;
    const close = (e) => {
      if (e.target.closest('#sidebar') || e.target.closest('#sidebarMenuBtn')) return;
      setMobileOpen(false);
    };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [mobileOpen]);

  return (
    <div className="synoti-ui">
      <ToastProvider>
        <TopbarNav
          currentPage={currentPage}
          user={user}
          onLogout={onLogout}
          onNavClick={onNavClick}
          onOpenPalette={onOpenPalette}
          onMenu={() => setMobileOpen((o) => !o)}
          logoUrl={logoUrl}
          {...sidebarProps}
        />
        <div className="app">
          <DesignSidebar
            currentPage={currentPage}
            sidebarCollapsed={sidebarCollapsed}
            mobileOpen={mobileOpen}
            onNavClick={onNavClick}
            onToggleCollapse={onToggleCollapse}
            userRole={sidebarProps.userRole}
            incidentCount={sidebarProps.incidentCount}
            incidentInProgress={sidebarProps.incidentInProgress}
            incidentInvestigating={sidebarProps.incidentInvestigating}
            busyWorkers={sidebarProps.busyWorkers}
            workerOnline={sidebarProps.workerOnline}
            pendingTasks={sidebarProps.pendingTasks}
            runningTasks={sidebarProps.runningTasks}
            failedTasks={sidebarProps.failedTasks}
            execRunningCount={sidebarProps.execRunningCount}
            vulnCritical={sidebarProps.vulnCritical}
            vulnHigh={sidebarProps.vulnHigh}
            vulnOthers={sidebarProps.vulnOthers}
          />
          <div className="sidebar-handle-slot">
            <button
              className="sidebar-handle"
              title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
              onClick={onToggleCollapse}
            >
              <Icon name={sidebarCollapsed ? 'chevron-right' : 'chevron-left'} size={15} />
            </button>
          </div>
          <main className="main">
            {children}
          </main>
        </div>
      </ToastProvider>
    </div>
  );
}

export default MainLayout;
